import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { selectActiveConversation } from '../../redux/reducers/directMessagesReducer';
import { useAppSelector } from '../../redux/store';
import { PANEL_FRAMELESS_CONTENT_PADDING_STRING } from '../../styles/styles';
import { PanelContainer } from '../panelStyles';
import { ActiveConversationDisplay } from './activeConversationDisplay';
import { ConversationsContainer } from './conversationsContainer';
export const DirectMessagesPanel = () => {
    // TODO: Improve this inefficient selector:
    const activeConversation = useAppSelector(selectActiveConversation);
    return (_jsx(PanelContainer, { padding: PANEL_FRAMELESS_CONTENT_PADDING_STRING, "aria-label": 'active conversation panel', children: activeConversation ? (_jsx(ActiveConversationDisplay, { conversation: activeConversation })) : (_jsx(ConversationsContainer, {})) }));
};
